import {Model} from './model';

export class User implements Model {
  userId: number;
  username: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  location: string;
  roles: string[];

  static copy(oldObj: User): User {
    const newObj = new User();
    newObj.userId = oldObj.userId;
    newObj.username = oldObj.username;
    newObj.email = oldObj.email;
    newObj.name = oldObj.name;
    newObj.firstName = oldObj.firstName;
    newObj.lastName = oldObj.lastName;
    newObj.location = oldObj.location;
    newObj.roles = Object.assign([], oldObj.roles);
    return newObj;
  }

  getPrimaryKey(): number {
    return this.userId;
  }

  isNew(): boolean {
    return isNaN(this.userId);
  }

  clone(): User {
    return User.copy(this);
  }
}
